import * as React from 'react';
import { Box } from "@mui/system"
import { Accordion, AccordionDetails, AccordionSummary, Button, CircularProgress, InputAdornment, TextField } from "@mui/material";
import Grid from "@mui/material/Grid2"
import { send_authorized_request } from '../../Constants/cognito'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SpeedIcon from '@mui/icons-material/Speed';
import { AXIOS_API_INSTANCE } from '../../Constants';
import axios from 'axios';
import Typography from '@mui/material/Typography';
import dayjs from "dayjs"
import UserAvatar from "../UserAvatar";
import { useSnackbar } from 'notistack';
import { moneyFormat } from '../../Utils';

export default function OdometerReadingsAccordion({ refresh_function, rental_item_id, disabled }) {
    const { enqueueSnackbar } = useSnackbar()
    const [newOdometerReading, setNewOdometerReading] = React.useState(0)
    const [odometerReadings, setOdometerReadings] = React.useState(undefined)
    const [isLoading, setIsLoading] = React.useState(true)

    const addOdometerReading = () => {
        const odometerReading = {
            rental_item_id: rental_item_id,
            value: newOdometerReading
        }
        send_authorized_request(() =>
            AXIOS_API_INSTANCE.put(
                `rentalitemsodometerreadings`,
                odometerReading
            ).then((response) => {
                enqueueSnackbar('Successfully created Odometer Reading', { variant: 'success' })
                setOdometerReadings(undefined)
            }).catch((error) => {
                enqueueSnackbar(`Failed to create Odometer Reading <${error.response?.data?.message ?? "Unknown Error Occurred"}>`, { variant: 'error' })
            })
        )
    }

    const getOdometerReadings = () => {
        setIsLoading(true)
        let filterVar = {
            "rental_item_id.eq": rental_item_id
        }
        const pageSize = 5
        send_authorized_request(() =>
            axios
                .all([
                    AXIOS_API_INSTANCE.get("rentalitemsodometerreadings", {
                        params: {
                            page_num: odometerReadings?.page || 0,
                            page_size: pageSize,
                            order_by: "date_created",
                            order_by_direction: "desc",
                            filters: JSON.stringify(filterVar),
                        },
                    }),
                ])
                .then(
                    axios.spread((newOdometerReadings) => {
                        console.log(newOdometerReadings)
                        setOdometerReadings({
                            rows: (odometerReadings?.rows || []).concat(newOdometerReadings.data.data),
                            total_count: newOdometerReadings.data.total_count,
                            page: (odometerReadings?.page || 0) + 1
                        })
                        setIsLoading(false)
                    })
                )
        )
    }
    React.useEffect(() => {
        if (odometerReadings === undefined) {
            getOdometerReadings()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [odometerReadings])

    return (
        (<Accordion disabled={disabled}>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="odometerreadings-content"
                id="odometerreadings-header"
            >
                <Typography>Odometer Readings</Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Box>
                    <TextField
                        margin="dense"
                        id={`odometer_reading`}
                        label="Odometer Reading"
                        type="number"
                        fullWidth
                        variant="standard"
                        value={newOdometerReading}
                        onChange={(event) => setNewOdometerReading(event.target.value)}
                        slotProps={{
                            input: {
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SpeedIcon />
                                    </InputAdornment>
                                )
                            }
                        }}
                    />
                    <Button variant="contained" onClick={addOdometerReading}>
                        Add Odometer Reading
                    </Button>
                    <Box sx={{ pb: 1 }}>
                        {
                            (odometerReadings?.rows || []).map((item) => {
                                return (
                                    (<Box key={item.id} sx={{ mb: 1 }}>
                                        <Grid container space={1}>
                                            <Grid size="auto">
                                                <span style={{ 'fontSize': '20px' }}><b>{dayjs.utc(item.date_created).local().format('M/D/YYYY h:mm A')} by {item.user.name}</b></span>
                                            </Grid>
                                            <Grid sx={{ pr: 2, pl: 2 }} size="auto">
                                                <UserAvatar user={item.user} />
                                            </Grid>
                                        </Grid>
                                        <Box sx={{ 'white-space': 'pre', m: 1, p: 1, backgroundColor: 'rgba(230, 230, 230, 1)', borderRadius: 2, boxShadow: 3 }}>
                                            <span>{moneyFormat(item.value)} mi</span>
                                        </Box>
                                    </Box>)
                                );
                            })
                        }
                    </Box>
                    <Grid container>
                        {isLoading &&
                            <Grid size="auto">
                                <Box>
                                    <CircularProgress />
                                </Box>
                            </Grid>
                        }
                        <Grid size="grow">
                            <Button variant='contained' disabled={isLoading || odometerReadings.rows.length === odometerReadings.total_count} onClick={getOdometerReadings}>Get More Odometer Readings ({odometerReadings?.rows?.length}/{odometerReadings?.total_count})</Button>
                        </Grid>
                    </Grid>
                </Box>
            </AccordionDetails>
        </Accordion>)
    );
}